import { render, staticRenderFns } from "./DrawerUserMenu.vue?vue&type=template&id=2c65e9a9"
import script from "./DrawerUserMenu.vue?vue&type=script&lang=js"
export * from "./DrawerUserMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawerUserMenu.vue?vue&type=style&index=0&id=2c65e9a9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports